import { CSSProperties, useMemo } from 'react';
import style from './promo-card.module.scss';
import Promo from '../../../models/promo/Promo';

export type CardProps = {
  cardContent: Promo;
  isOneThird: boolean;
};

export default function PromoCard({ cardContent, isOneThird }: CardProps) {
  const cardStyle = useMemo(() => {
    return {
      '--promo-card-copy-color': cardContent.copyColor,
      '--promo-card-bg-color': cardContent.backgroundColor,
      '--promo-card-cta-icon': cardContent.ctaIcon
        ? `url('/public/next-assets/icons/promo/${cardContent.ctaIcon.toLowerCase()}.svg')`
        : ``,
      '--promo-card-cta-icon-hover': cardContent.ctaIcon
        ? `url('/public/next-assets/icons/promo/${cardContent.ctaIcon.toLowerCase()}-hover.svg')`
        : ``,
    } as CSSProperties;
  }, [cardContent]);

  return (
    <a
      style={cardStyle}
      href={cardContent.cta.urlLink}
      target={cardContent.cta.openLinkInNewTab ? `_blank` : `_self`}
      className={`${style[`promo-card`]} ${isOneThird ? style[`one-third`] : null} promo-card`}
      rel='noreferrer'
    >
      <div className={`${style[`promo-card-img`]}`}>
        <img src={cardContent.image?.secureUrl} alt={`${cardContent.image?.alt}`} />
      </div>
      <div
        style={{ backgroundColor: 'var(--promo-card-bg-color)' }}
        className={`${style[`promo-card-content`]} promo-card-content`}
      >
        <div className={'row'}>
          <div className='col-10'>
            <div
              style={{ color: 'var(--promo-card-copy-color)' }}
              className={`${style[`promo-card-copy`]} promo-card-copy`}
            >
              {cardContent.copy}
            </div>
          </div>
          <div className='d-flex align-items-end justify-content-end col-2'>
            <button type='button' className={`${style[`promo-card-cta`]} promo-card-cta`}>
              <span className='visually-hidden'>{cardContent.cta.ctaText}</span>
            </button>
          </div>
        </div>
      </div>
    </a>
  );
}
